// BANDEJA PRODUCT PAGE | PADEL DAMPENERS | JS ASSET FILE
// File name in Shopify Assets: bandeja-padel-dampeners-product.js
// This script syncs Shopify stock and prices automatically from /products/padel-dampeners.js.
// Keep this file in Edit Code > Assets.

(function() {
  'use strict';

  var section = document.getElementById('bandeja-dampeners-product-page');
  if (!section) return;

  var mainProductHandle = 'padel-dampeners';
  var mainVariantId = 43323173896240;
  var whatsappNumber = '9613735578';
  var productTitle = 'Padel Dampeners';
  var productImage = 'https://cdn.shopify.com/s/files/1/0692/1732/1008/files/dampeners.jpg?v=1782474057';
  var fallbackPriceCents = 1500;
  var freeDeliveryThresholdCents = 4500;
  var deliveryFeeCents = 400;

  var upsellConfigs = [
    {
      variantId: 43323155382320,
      handle: 'manual-ball-pressurizer',
      priceElementId: 'bdp-upsell-price-1',
      title: 'Manual Pressurizer',
      image: 'https://cdn.shopify.com/s/files/1/0692/1732/1008/files/pressurizer_only.jpg?v=1782476443',
      productUrl: '/products/manual-ball-pressurizer',
      fallbackPriceCents: 3999
    },
    {
      variantId: 43323174387760,
      handle: 'score-pointer',
      priceElementId: 'bdp-upsell-price-2',
      title: 'Scoring Pointer',
      image: 'https://cdn.shopify.com/s/files/1/0692/1732/1008/files/score_pointer.jpg?v=1782474256',
      productUrl: '/products/score-pointer',
      fallbackPriceCents: 700
    }
  ];

  var quantity = 1;
  var currentVariantId = mainVariantId;
  var currentVariantTitle = '';
  var currentPriceCents = fallbackPriceCents;
  var currentCompareCents = 0;
  var isInStock = true;
  var isSyncing = false;
  var upsellData = {};

  var quantitySpan = document.getElementById('bdp-quantity');
  var minusBtn = document.getElementById('bdp-qty-minus');
  var plusBtn = document.getElementById('bdp-qty-plus');
  var addToCartBtn = document.getElementById('bdp-add-to-cart');
  var successMsg = document.getElementById('bdp-cart-success');
  var mainPriceEl = document.getElementById('bdp-main-price');
  var comparePriceEl = document.getElementById('bdp-compare-price');
  var saveBadgeEl = document.getElementById('bdp-save-badge');
  var whatsappBtn = document.getElementById('bdp-whatsapp-btn');
  var stockLine = document.getElementById('bdp-stock-line');
  var stockText = document.getElementById('bdp-stock-text');

  function formatMoney(cents) {
    var amount = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount);
    }

    return '$' + (amount / 100).toFixed(2);
  }

  function showMessage(message, isError) {
    if (!successMsg) return;

    successMsg.textContent = message;
    successMsg.style.color = isError ? '#ff8a8a' : '#d3ff21';
    successMsg.classList.add('show');

    window.setTimeout(function() {
      successMsg.classList.remove('show');
    }, 2400);
  }

  function getDisplayProductTitle() {
    if (currentVariantTitle && currentVariantTitle !== 'Default Title') {
      return productTitle + ' ' + currentVariantTitle;
    }

    return productTitle;
  }

  function getDeliveryCents(subtotalCents) {
    return subtotalCents >= freeDeliveryThresholdCents ? 0 : deliveryFeeCents;
  }

  function updateWhatsAppLink() {
    if (!whatsappBtn) return;

    var subtotalCents = currentPriceCents * quantity;
    var deliveryCents = getDeliveryCents(subtotalCents);
    var totalCents = subtotalCents + deliveryCents;
    var deliveryText = deliveryCents === 0
      ? 'free delivery'
      : 'delivery fee ' + formatMoney(deliveryCents);

    var message = 'Hello i am intrested in ' + getDisplayProductTitle() +
      ' for quantity ' + quantity +
      ' and price of ' + formatMoney(currentPriceCents) +
      ' with ' + deliveryText +
      '. Total=' + formatMoney(totalCents);

    whatsappBtn.href = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(message);
  }

  function updateQuantityDisplay() {
    if (quantitySpan) quantitySpan.textContent = String(quantity);
    updateWhatsAppLink();
  }

  function updateAddToCartButton() {
    if (!addToCartBtn) return;

    if (!isInStock) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Sold Out';
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add To Cart';
    }
  }

  function updateStockDisplay() {
    if (!stockLine || !stockText) return;

    stockLine.classList.toggle('is-sold-out', !isInStock);
    stockText.textContent = isInStock ? 'In stock and ready to ship' : 'Sold out';
  }

  function updateComparePrice() {
    var hasCompare = currentCompareCents > currentPriceCents;

    if (comparePriceEl) {
      if (hasCompare) {
        comparePriceEl.textContent = formatMoney(currentCompareCents);
        comparePriceEl.style.display = 'inline-flex';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }

    if (saveBadgeEl) {
      if (hasCompare) {
        saveBadgeEl.textContent = 'SAVE ' + formatMoney(currentCompareCents - currentPriceCents).replace('.00', '');
        saveBadgeEl.style.display = 'inline-flex';
      } else {
        saveBadgeEl.textContent = '';
        saveBadgeEl.style.display = 'none';
      }
    }
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) throw new Error('Failed to load product ' + handle);
      return response.json();
    });
  }

  function findVariant(product, preferredVariantId) {
    if (!product || !product.variants || !product.variants.length) return null;

    var preferred = product.variants.find(function(variant) {
      return String(variant.id) === String(preferredVariantId);
    });

    if (preferred) return preferred;

    var available = product.variants.find(function(variant) {
      return Boolean(variant.available);
    });

    return available || product.variants[0];
  }

  function syncMainProductData() {
    if (isSyncing) return Promise.resolve();
    isSyncing = true;

    return fetchProduct(mainProductHandle).then(function(product) {
      var variant = findVariant(product, mainVariantId);
      if (!variant) return;

      currentVariantId = variant.id;
      currentVariantTitle = variant.title || '';
      currentPriceCents = Number(variant.price || fallbackPriceCents);
      currentCompareCents = Number(variant.compare_at_price || 0);
      isInStock = Boolean(variant.available);

      if (mainPriceEl) mainPriceEl.textContent = formatMoney(currentPriceCents);

      updateComparePrice();
      updateStockDisplay();
      updateAddToCartButton();
      updateWhatsAppLink();
    }).catch(function(error) {
      console.warn('Bandeja dampeners sync failed:', error);

      currentPriceCents = fallbackPriceCents;

      if (mainPriceEl) mainPriceEl.textContent = formatMoney(fallbackPriceCents);

      updateComparePrice();
      updateStockDisplay();
      updateAddToCartButton();
      updateWhatsAppLink();
    }).finally(function() {
      isSyncing = false;
    });
  }

  function syncUpsellProduct(config) {
    return fetchProduct(config.handle).then(function(product) {
      var variant = findVariant(product, config.variantId);
      if (!variant) return;

      var priceCents = Number(variant.price || config.fallbackPriceCents);
      var inStock = Boolean(variant.available);

      upsellData[String(config.variantId)] = {
        variantId: variant.id,
        title: config.title,
        priceCents: priceCents,
        inStock: inStock,
        image: config.image,
        handle: config.handle,
        productUrl: config.productUrl
      };

      var priceEl = document.getElementById(config.priceElementId);
      if (priceEl) priceEl.textContent = formatMoney(priceCents);

      var card = section.querySelector('.bdp-upsell-card[data-upsell-variant-id="' + config.variantId + '"]');
      var btn = card ? card.querySelector('.bdp-upsell-add-btn') : null;

      if (btn) {
        btn.disabled = !inStock;
        btn.textContent = inStock ? 'Add To Cart' : 'Sold Out';
      }
    }).catch(function(error) {
      console.warn('Bandeja upsell sync failed:', config.handle, error);

      upsellData[String(config.variantId)] = {
        variantId: config.variantId,
        title: config.title,
        priceCents: config.fallbackPriceCents,
        inStock: true,
        image: config.image,
        handle: config.handle,
        productUrl: config.productUrl
      };

      var priceEl = document.getElementById(config.priceElementId);
      if (priceEl) priceEl.textContent = formatMoney(config.fallbackPriceCents);
    });
  }

  function syncAllUpsells() {
    return Promise.all(upsellConfigs.map(syncUpsellProduct));
  }

  function addToCartViaShopify(variantId, title, image, handle, qty, priceCents, variantTitle) {
    var quantityToAdd = qty || 1;

    if (typeof window.addToCart === 'function') {
      return window.addToCart({
        title: title,
        variant: variantTitle || '',
        price: formatMoney(priceCents),
        variantId: String(variantId),
        quantity: quantityToAdd,
        image: image,
        handle: handle
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantityToAdd
      })
    }).then(function(response) {
      if (!response.ok) {
        return response.json().catch(function() {
          return null;
        }).then(function(errorData) {
          throw new Error(errorData && errorData.description ? errorData.description : 'Failed to add to cart');
        });
      }

      if (typeof window.openBandejaCartDrawer === 'function') {
        window.openBandejaCartDrawer();
      }

      document.dispatchEvent(new CustomEvent('bandeja:cart:open', { detail: { bandejaAllowed: true } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  function handleMainAddToCart() {
    if (!isInStock) {
      showMessage('This product is out of stock.', true);
      return;
    }

    if (!addToCartBtn) return;

    var originalText = addToCartBtn.textContent;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding';

    addToCartViaShopify(
      currentVariantId,
      getDisplayProductTitle(),
      productImage,
      mainProductHandle,
      quantity,
      currentPriceCents,
      currentVariantTitle
    ).then(function() {
      showMessage('Added ' + quantity + ' item to cart.');
    }).catch(function(error) {
      showMessage(error && error.message ? error.message : 'Error adding to cart.', true);
    }).finally(function() {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = originalText;
      updateAddToCartButton();
    });
  }

  function handleUpsellAddToCart(event, btn, variantId) {
    event.preventDefault();
    event.stopPropagation();

    var data = upsellData[String(variantId)];

    if (!data) {
      showMessage('Product data is still loading.', true);
      return;
    }

    if (!data.inStock) {
      showMessage(data.title + ' is sold out.', true);
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';

    addToCartViaShopify(
      data.variantId,
      data.title,
      data.image,
      data.handle,
      1,
      data.priceCents,
      ''
    ).then(function() {
      showMessage(data.title + ' added to cart.');
    }).catch(function(error) {
      showMessage(error && error.message ? error.message : 'Error adding to cart.', true);
    }).finally(function() {
      btn.disabled = false;
      btn.textContent = originalText;
    });
  }

  if (minusBtn) {
    minusBtn.addEventListener('click', function() {
      if (quantity > 1) {
        quantity -= 1;
        updateQuantityDisplay();
      }
    });
  }

  if (plusBtn) {
    plusBtn.addEventListener('click', function() {
      quantity += 1;
      updateQuantityDisplay();
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleMainAddToCart);
  }

  section.querySelectorAll('.bdp-upsell-add-btn').forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      var variantId = btn.getAttribute('data-variant-id');
      handleUpsellAddToCart(event, btn, variantId);
    });
  });

  section.querySelectorAll('.bdp-upsell-card').forEach(function(card) {
    card.addEventListener('click', function(event) {
      if (event.target.closest('.bdp-upsell-add-btn')) return;

      var url = card.getAttribute('data-upsell-url');
      if (url) window.location.href = url;
    });
  });

  var reviewLink = section.querySelector('.bdp-review-count');
  if (reviewLink) {
    reviewLink.addEventListener('click', function() {
      var reviewsSection = document.getElementById('shopify-product-reviews') || document.querySelector('[data-reviews]');
      if (reviewsSection) reviewsSection.scrollIntoView({ behavior: 'smooth' });
    });
  }

  section.querySelectorAll('.bdp-collapsible').forEach(function(collapsible) {
    var header = collapsible.querySelector('.bdp-collapsible-header');

    if (!header) return;

    function toggleCollapsible() {
      var isOpen = collapsible.classList.contains('is-open');
      collapsible.classList.toggle('is-open', !isOpen);
      header.setAttribute('aria-expanded', String(!isOpen));
    }

    header.addEventListener('click', toggleCollapsible);

    header.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleCollapsible();
      }
    });
  });

  updateQuantityDisplay();
  updateAddToCartButton();
  updateStockDisplay();

  syncMainProductData();
  syncAllUpsells();

  window.setInterval(syncMainProductData, 300000);
  window.setInterval(syncAllUpsells, 300000);
})();
